import { useCallback, useEffect, useMemo } from 'react';
import { useRemotionPlayerPause } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerPause';
import { isAnyDialogOpened } from '@/Pages/Sessions/uiComponents/ContentDialog/utils';

export const useShortcuts = () => {
  const { isPlaying, play, pause } = useRemotionPlayerPause();
  const keyboardInputBlocked = useMemo(() => window.location.pathname.includes('/blog'), []);

  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      // Only handle space key press
      if (
        event.code === 'Space' &&
        !keyboardInputBlocked &&
        (event.target as HTMLElement).tagName.toLowerCase() !== 'input' &&
        (event.target as HTMLElement).tagName.toLowerCase() !== 'textarea' &&
        (event.target as HTMLElement).contentEditable !== 'true' &&
        !isAnyDialogOpened()
      ) {
        event.preventDefault(); // Prevent default space scroll behavior
        if (isPlaying) {
          pause();
        } else {
          play();
        }
      }
    },
    [keyboardInputBlocked, isPlaying, pause, play]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleKeyPress]);
};
